import { firstDayOfWeek } from '@enterprise/core';

/**
 * Calculates the date range covering the entire month of the given date,
 * extended to include all days of the weeks that intersect with the month.
 * The range starts from the first day of the week containing the first day of the month,
 * and ends on the last day of the week containing the last day of the month.
 *
 * @param date - A `Date` object representing any day within the target month.
 * @returns An object containing:
 *   - `first`: The `Date` of the first day of the range (start of the week containing the month's first day).
 *   - `last`: The `Date` of the last day of the range (end of the week containing the month's last day).
 */
export const useMonthRange = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstOfMonth = new Date(year, month, 1);
  const lastOfMonth = new Date(year, month + 1, 0);

  const dayOfWeek = firstDayOfWeek();
  const lastDayOfWeek = (dayOfWeek + 6) % 7;

  const firstDay = new Date(firstOfMonth);
  const dayDiff = (firstDay.getDay() - dayOfWeek + 7) % 7;

  firstDay.setDate(firstDay.getDate() - dayDiff);

  const lastDay = new Date(lastOfMonth);
  const dayDiffEnd = (lastDayOfWeek - lastDay.getDay() + 7) % 7;

  lastDay.setDate(lastDay.getDate() + dayDiffEnd);

  return { endDate: lastDay, startDate: firstDay };
};
